import { RadioGroup } from '@headlessui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from './FormGroup';

export const YesNoFormGroup: React.FC<
    {
        value: 'yes' | 'no' | null;
        onChange: (value: 'yes' | 'no' | null) => void;
        onYes?: () => void;
        onNo?: () => void;
    } & React.ComponentProps<typeof FormGroup>
> = ({ onChange, onYes, onNo, value, ...rest }) => {
    const { t } = useTranslation('pension');

    return (
        <FormGroup {...rest}>
            <RadioGroup
                value={value}
                onChange={(value) => {
                    if (value === 'yes') {
                        onYes?.();
                    }
                    if (value === 'no') {
                        onNo?.();
                    }
                    onChange(value);
                }}
            >
                <div className="flex flex-row sm:gap-4">
                    <RadioGroup.Option value="yes">
                        {({ checked }) => {
                            return (
                                <div className="radio-item inline-flex items-center">
                                    <input checked={checked} id="radio_yes " type="radio" readOnly/>
                                    <label
                                        htmlFor="radio-yes"
                                        className={`leading-radio-button ${checked ? 'text-bnd-green' : ''}`}
                                    >
                                        {t('general-yes')}
                                    </label>
                                </div>
                            );
                        }}
                    </RadioGroup.Option>
                    <RadioGroup.Option value="no">
                        {({ checked }) => {
                            return (
                                <div className="radio-item inline-flex items-center">
                                    <input checked={checked} id="radio-no" type="radio" readOnly/>
                                    <label
                                        htmlFor="radio-no"
                                        className={`leading-radio-button ${checked ? 'text-bnd-green' : ''}`}
                                    >
                                        {t('general-no')}
                                    </label>
                                </div>
                            );
                        }}
                    </RadioGroup.Option>
                </div>
            </RadioGroup>
        </FormGroup>
    );
};
